import { IS_BROWSER } from './constantsClient';

export const isIosSafari = (): boolean => {
  const isIos = IS_BROWSER ? /iP(ad|od|hone)/i.test(window.navigator.userAgent) : false;
  // eslint-disable-next-line no-useless-escape
  const isSafari = IS_BROWSER ? !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/) : false;
  return isIos && isSafari;
};
